import React, { useState } from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    useHistory,
    Redirect,
} from 'react-router-dom'
import 'react-loading-skeleton/dist/skeleton.css'
import Navbar from './navBar/Navbar'
import Footer from './footer/Footer'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import PrivateRoute from './PrivateRoute'
import Login from './navigationComponents/login/Login'
import LoginAndSecurity from './myAccount/loginAndSecurity/LoginAndSecurity'
import PaymentDetails from './myAccount/paymentDetails/PaymentDetails'
import SignUp from './navigationComponents/signUp/SignUp'
import GuestChargingEntry from './navigationComponents/guestCharging/GuestChargingEntry'
import MyAccount from './myAccount/MyAccount'
import NewLandingPage from './newLandingPage/NewLandingPage'
import NotFound from './notFound/NotFound'
import SetupProcess from './setupProcess/SetupProcess'
import Dashboard from './navigationComponents/dashboard/Dashboard'
import InstallerDashboard from './navigationComponents/installerDashboard/InstallerDashboard'
import LogoutModal from './navigationComponents/logout/LogOutModal'
import { CookiesProvider } from 'react-cookie'
import './App.css'
import ChangePassword from './myAccount/changePassword/ChangePassword'
import ChangeProperty from './myAccount/changeProperty/ChangeProperty'
import { ProvideAuth } from './auth/Auth'
import { ProvideData } from './data/DataProvider'
import { ProvidePassword } from './auth/PasswordContext'
import ResetPassword from './navigationComponents/login/ResetPassword'
import ToastProvider from './providers/ToastProvider'
import { MAIN_DOMAIN } from './constants'

function App() {
    const [openModal, setOpenModal] = useState(false)

    const history = useHistory()

    const logout = () => {
        setOpenModal(true)
    }

    const handleClose = () => {
        setOpenModal(false)
    }

    return (
        <ProvideAuth>
            <ProvideData>
                <ProvidePassword>
                    <CookiesProvider>
                        <ToastProvider>
                            <Router>
                            <div className="App">
                                <Navbar logout={logout} />
                                <Switch>
                                    <Route
                                        exact
                                        path="/"
                                        render={(props) => {
                                            return (
                                                <Redirect
                                                    to={{
                                                        pathname: '/dashboard',
                                                    }}
                                                />
                                            )
                                        }}
                                    />
                                    <Route path="/sign-in" component={Login} />
                                    <PrivateRoute
                                        path="/setup"
                                        componentToReturn={
                                            <SetupProcess
                                                history={history}
                                                path="select-vehicle"
                                            />
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/sign-up"
                                        component={SignUp}
                                    />
                                    <Route
                                        exact
                                        path="/sign-up/:pathId"
                                        render={(props) => {
                                            return <SignUp history={history} />
                                        }}
                                    />
                                    <Route
                                        exact
                                        path="/guestCharging/:pathId"
                                        component={GuestChargingEntry}
                                    />
                                    <Route
                                        exact
                                        path="/forgot-password"
                                        component={ResetPassword}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/dashboard"
                                        componentToReturn={<Dashboard />}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/dashboard/:pathId"
                                        componentToReturn={<Dashboard />}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/dashboard/:pathId/:secondPathId"
                                        componentToReturn={<Dashboard />}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/installer-dashboard"
                                        componentToReturn={
                                            <InstallerDashboard />
                                        }
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/my-account"
                                        componentToReturn={<MyAccount />}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/my-account/edit-login"
                                        componentToReturn={<LoginAndSecurity />}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/my-account/payment-details"
                                        componentToReturn={<PaymentDetails />}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/my-account/change-password"
                                        componentToReturn={<ChangePassword />}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/my-account/change-property"
                                        componentToReturn={<ChangeProperty />}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/setup/:pathId"
                                        componentToReturn={
                                            <SetupProcess history={history} />
                                        }
                                    />
                                    {/* JOIN PROPERTY BY QR CODE  */}
                                    <Route
                                        path="/joinProperty/:pathId"
                                        render={(props) => (
                                            <NewLandingPage history={history} />
                                        )}
                                    />
                                    {/* ReadiCover QR CODE  */}
                                    <Route
                                        path="/readicover"
                                        render={(props) => {
                                            const queryParams = new URLSearchParams(
                                                props.location.search
                                            )
                                            const pathId = queryParams.get(
                                                'uuid'
                                            )
                                            // Redirect if 'uuid' exists
                                            if (pathId) {
                                                // Redirect to external URL
                                                window.location.href = `${MAIN_DOMAIN}/readicover?uuid=${pathId}`
                                                return null // Return null while the redirection is in progress
                                            } else {
                                                // Optionally handle the case where 'uuid' is not present
                                                return (
                                                    <div>UUID not provided</div>
                                                )
                                            }
                                        }}
                                    />
                                    {/*
                                        LEGACY PATH ALIASES — PERMANENT, DO NOT REMOVE.

                                        These paths are baked into artifacts we cannot
                                        redeploy, so they are a public API of this app:
                                          /signup/:pathId — invite emails, built by the
                                            backend as INVITE_LINK_DOMAIN + '/' + uuid
                                            (gopowerev-backend ses_service.py). Emitted
                                            lowercase; route matching is case-insensitive,
                                            so this entry covers /signUp/:pathId too.
                                          /signUp — shipped iOS consumer and installer
                                            binaries open homeURL + "/signUp" in an
                                            SFSafariViewController. Already-installed
                                            copies can never be fixed by a deploy.
                                        /login and /resetPassword have no known external
                                        emitter, but cost nothing and cover bookmarks.

                                        Placed last so an alias can never shadow a real
                                        route; only unmatched paths reach them.
                                    */}
                                    <Redirect
                                        exact
                                        from="/signup/:pathId"
                                        to="/sign-up/:pathId"
                                    />
                                    <Redirect exact from="/signUp" to="/sign-up" />
                                    <Redirect exact from="/login" to="/sign-in" />
                                    <Redirect
                                        exact
                                        from="/resetPassword"
                                        to="/forgot-password"
                                    />
                                    {/* CATCH-ALL 404 — keep last */}
                                    <Route component={NotFound} />
                                </Switch>
                                <Footer />
                                {/* ARE YOU SURE YOU WANT TO LOGOUT MODAL */}
                                <LogoutModal
                                    handleClose={handleClose}
                                    open={openModal}
                                />
                            </div>
                        </Router>
                    </ToastProvider>
                </CookiesProvider>
                </ProvidePassword>
            </ProvideData>
        </ProvideAuth>
    )
}

export default App
